import React from 'react'
import { components, constants } from 'cng-web-lib'
import FormProperties from './TrailerDTOFormProperties'
import { Box, Grid } from '@material-ui/core'
import CngSection from 'src/components/cngcomponents/CngSection'
import CngField from 'src/components/cngcomponents/CngField'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngButton, CngPrimaryButton },
  form: { CngForm },
  CngDialog
} = components

const { FormState } = constants

function TrailerDTODialog(props) {
  const {
    getLookupValue,
    getCountryStateLabel,
    onAddTrailerDTO,
    onEditTrailerDTO,
    isView,
    onClose,
    open,
    showNotification,
    trailerDTO
  } = props

  const { initialValues, makeValidationSchema } = FormProperties.formikProps
  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText() 
  
  return (
    <CngDialog
      dialogContent={
        isView && trailerDTO ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CngSection title={aciHighwayManifestTranslationText.trailerDTOTitle}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <CngField label={aciHighwayManifestTranslationText.cargoLoadedIn}>
                      {getLookupValue('cargoLoadedIn', trailerDTO.cargoLoadedIn)}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CngField label={aciHighwayManifestTranslationText.equipmentNumber}>
                      {trailerDTO.equipmentNumber}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CngField label={aciHighwayManifestTranslationText.licensePlateNum}>
                      {trailerDTO.licensePlateNum}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CngField label={aciHighwayManifestTranslationText.country}>
                      {getLookupValue('countries', trailerDTO.countryCode)}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CngField label={aciHighwayManifestTranslationText.state}>
                      {getCountryStateLabel(trailerDTO.countryCode, trailerDTO.stateCode)}
                    </CngField>
                  </Grid>
                </Grid>
              </CngSection>
            </Grid>
            <Grid item xs={12}>
              <CngSection title={aciHighwayManifestTranslationText.containerTitle}>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.container1}>
                      {trailerDTO.container1}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.container2}>
                      {trailerDTO.container2}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.container3}>
                      {trailerDTO.container3}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.container4}>
                      {trailerDTO.container4}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.container5}>
                      {trailerDTO.container5}
                    </CngField>
                  </Grid>
                </Grid>
              </CngSection>
            </Grid>
            <Grid item xs={12}>
              <CngSection title={aciHighwayManifestTranslationText.sealTitle}>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo1}>
                      {trailerDTO.sealNo1}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo2}>
                      {trailerDTO.sealNo2}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo3}>
                      {trailerDTO.sealNo3}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo4}>
                      {trailerDTO.sealNo4}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo5}>
                      {trailerDTO.sealNo5}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo6}>
                      {trailerDTO.sealNo6}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo7}>
                      {trailerDTO.sealNo7}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo8}>
                      {trailerDTO.sealNo8}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo9}>
                      {trailerDTO.sealNo9}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo10}>
                      {trailerDTO.sealNo10}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo11}>
                      {trailerDTO.sealNo11}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo12}>
                      {trailerDTO.sealNo12}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo13}>
                      {trailerDTO.sealNo13}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo14}>
                      {trailerDTO.sealNo14}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo15}>
                      {trailerDTO.sealNo15}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo16}>
                      {trailerDTO.sealNo16}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo17}>
                      {trailerDTO.sealNo17}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo18}>
                      {trailerDTO.sealNo18}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo19}>
                      {trailerDTO.sealNo19}
                    </CngField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <CngField label={aciHighwayManifestTranslationText.sealNo20}>
                      {trailerDTO.sealNo20}
                    </CngField>
                  </Grid>
                </Grid>
              </CngSection>
            </Grid>
            <Grid item xs={12}>
              <CngSection title={aciHighwayManifestTranslationText.exceptioncargoTitle}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={aciHighwayManifestTranslationText.iit}>
                      {trailerDTO.iit}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={aciHighwayManifestTranslationText.lvs}>
                      {trailerDTO.lvs}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={aciHighwayManifestTranslationText.postal}>
                      {trailerDTO.postal}
                    </CngField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CngField label={aciHighwayManifestTranslationText.flyingTrucks}>
                      {trailerDTO.flyingTrucks}
                    </CngField>
                  </Grid>
                </Grid>
              </CngSection>
            </Grid>
          </Grid>
        ) : (
          <CngForm
            fieldLevel='form'
            formikProps={{
              initialValues: trailerDTO || initialValues,
              makeValidationSchema: makeValidationSchema,
              onSubmit: (data) => {
                if (trailerDTO) {
                  onEditTrailerDTO(data)
                } else {
                  onAddTrailerDTO(data)
                }

                onClose()
              }
            }}
            formState={FormState.COMPLETED}
            renderBodySection={(labelMap, shouldHideMap) => (
              <Box padding={1}>
                <FormProperties.Fields
                  showNotification={showNotification}
                  shouldHideMap={shouldHideMap}
                />
              </Box>
            )}
            innerForm={true}
            renderButtonSection={() => (
              <Box display='flex' justifyContent='flex-end'>
                <CngPrimaryButton type='submit'>
                  {trailerDTO
                    ? aciHighwayManifestTranslationText.updateButton
                    : aciHighwayManifestTranslationText.saveButton}
                </CngPrimaryButton>
              </Box>
            )}
          />
        )
      }
      dialogAction={
        isView ? <CngButton onClick={onClose}>{aciHighwayManifestTranslationText.okayButton}</CngButton> : null
      }
      dialogTitle={aciHighwayManifestTranslationText.trailerDTOTitle}
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      fullWidth
      maxWidth='lg'
      onClose={onClose}
      open={open}
      shouldShowCloseButton
    />
  )
}

export default TrailerDTODialog
